export default "__VITE_ASSET__CaVjY0Uy__"